export default __webpack_public_path__ + "static/media/logo-ae-west-elm.71cea8b1.svg";